// modules
import React, { PureComponent } from 'react';
import classnames from 'classnames';
import { toPairs } from 'ramda';

// aliased
import socialLinks from 'data/social-links';
import DocumentTitle from 'components/DocumentTitle';
import CityLove from 'components/CityLove';
import Link from 'components/Link';

// local
import ProfileMain from './ProfileMain';
import styles from './HomeView.pcss';

const LINKS = toPairs(socialLinks)
  .map(([text, { url, icon }]) => (
    <Link className={ styles.link } key={ text } to={ url } title={ text }>
      <img className={ styles.icon } src={ icon } />
    </Link>
  ));

export default class HomeView extends PureComponent {
  
  static propTypes = {}
  static defaultProps = {}

  render() {
    const cityloveClasses = classnames(styles.cityLove);
    
    return (
      <div className={ styles.homeView }>
        <DocumentTitle title={ 'Colby Dauphinais' } />
        <ProfileMain className={ styles.profileMain } />
        <CityLove
          className={ cityloveClasses }
          cities={ ['pdx'] } />
        <div className={ styles.links }>{ LINKS }</div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/views/HomeView/index.jsx